module.exports = {
          srcSet: __webpack_public_path__ + "428170a2dae3339e1afcc6cca7e9d7fb-65.png"+" 65w",
          images:[ {path: __webpack_public_path__ + "428170a2dae3339e1afcc6cca7e9d7fb-65.png",width: 65,height: 41}],
          src: __webpack_public_path__ + "428170a2dae3339e1afcc6cca7e9d7fb-65.png",
          toString:function(){return __webpack_public_path__ + "428170a2dae3339e1afcc6cca7e9d7fb-65.png"},
          
          width: 65,
          height: 41
        }